import React from "react";
import { Label } from "reactstrap";
import CreatableSelect from "react-select/creatable";
import Required from "./Required";
import { handleSelectChange } from "../../../utils/Utils";

const MyCreateSelect = ({ title, multi, name, placeholder, register, watch, errors, setValue, trigger, options }) => {
  return (
    <div className="form-group my-2">
      <Label className="from-label" htmlFor={name}>
        {title}
        <Required />
      </Label>
      <div className="form-control-wrap">
        <CreatableSelect
          isMulti
          placeholder={placeholder}
          className=""
          id={name}
          {...register(name, {
            required: `Please select ${title}`,
          })}
          onChange={(e) => handleSelectChange(e, name, setValue, trigger)}
          value={watch(name)}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: errors?.[name] ? "red" : "grey",
            }),
          }}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyCreateSelect;
